import { render, staticRenderFns } from "./BeaconIdRecord.vue?vue&type=template&id=8ca68f6c&scoped=true&"
import script from "./BeaconIdRecord.vue?vue&type=script&lang=js&"
export * from "./BeaconIdRecord.vue?vue&type=script&lang=js&"
import style0 from "./BeaconIdRecord.vue?vue&type=style&index=0&id=8ca68f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca68f6c",
  null
  
)

export default component.exports